import { Button, Col, Form, Input, message, notification, Popconfirm, Popover, Row, Select, Spin, Upload } from "antd"
import { useEffect, useState } from "react";
import { UploadOutlined, CloseCircleOutlined } from '@ant-design/icons';

import { setHeaderName } from "../../../../services/SetHeaderName";
import '../style/AddIngredients.scss'
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, NUMBER_AND_FRACTIONAL_PATTERN, NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE } from "../../../../config/constant";
import { addIngredientsApi, editIngredientsApi, listOfIngredientFormApi, listOfIngredientsApi, listOfMacrosMicrosApi, listOfRecipeTagsApi, updateIngredientsApi } from "../../../../config/Api";
import { FilterApiData } from "../../../../services/FilterApiData";
import { useNavigate, useParams } from "react-router-dom";
import { read, utils, write } from 'xlsx';

export const AddIngredientLateast = () => {
    const [form] = Form.useForm();
    const { id } = useParams()
    const { Option } = Select;
    const navigate = useNavigate()

    const Ingredient = {
        name: "Bajara",
        ingredientEnglishName: "pearl millet",
        form_wise_macros_micros: [
            {
                form_id: 1, //raw form
                unit: [{
                    unit_id: 1, // cup
                    gram: 160,
                },
                {
                    unit_id: 2, // teaspoon
                    gram: 10,
                }],
                IngredientsMacrosMicros: [
                    {
                        macros_micros_id: 1, // Vitamin A
                        per_gram_value: 0.50,
                        type: 'Macros',
                        unit: 'g' // gram
                    },
                    {
                        macros_micros_id: 2, // Energy
                        per_gram_value: 0.30,
                        type: 'Micros',
                        unit: 'Kcal' // gram
                    }
                ]
            }
        ]
    }


    const [fileList, setFileList] = useState([]);

    const [flag, setFlag] = useState(false);
    const [ingredientName, setIngredientName] = useState('');
    const [ingredienEnglishtName, setIngredientEnglishName] = useState('');
    const [ingredientFormOptions, setIngredientFormOptions] = useState([]);
    const [MacrosMicrosList, setMacrosMicrosList] = useState([]);
    const [recipeTagsOptions, setRecipeTagsOptions] = useState([])
    const [arrayOfSelectedDropdownValue, setArrayOfSelectedDropdownValue] = useState([])
    const [defaultFormValue, setDefaultFormValue] = useState('')
    const [loading, setLoading] = useState(false)

    const [ingredientsList, setIngredientsList] = useState([]);

    const [ingredientData, setIngredientData] = useState({
        name: "",
        ingredientEnglishName: "",
        ingredient_description: "",
        form_wise_macros_micros: [{
            ingredients_form_id: 1,
            "ingredient_macros_micros": []
            // MacrosMicrosList.map(entry =>
            //         entry.ingredients_form_id = value)
        }]

    });

    // console.log("ingredientData", ingredientData);
    // get the list of all Recipe Tags -> for get disease options  
    const getListOfRecipeTags = () => {
        listOfRecipeTagsApi()
            .then((res) => {
                if (res.status === 200) {
                    setRecipeTagsOptions(FilterApiData(res.data.data));
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    const fillIngredientDataForEdit = (ingredientRecord) => {
        form.setFieldsValue({
            "name": ingredientRecord.name,
            "english_name": ingredientRecord.ingredientEnglishName,
            "ingredient_description": ingredientRecord.ingredient_description,
        })

        // loop on form
        ingredientRecord.form_wise_macros_micros.map((formRecord, formRecordIndex) =>
            <>
                {console.log("formRecord", formRecord)}
                {/* set selected form dropdown from id */}
                {form.setFieldsValue({
                    ["entry" + formRecordIndex]: formRecord?.ingredients_form_id
                })}
                {/* // loop on that particulat form macros micros values */}
                {formRecord?.ingredient_macros_micros.map((nutrionValue, nutrionValueIndex) => {
                    form.setFieldsValue({
                        ["element" + formRecordIndex + nutrionValueIndex]: parseFloat(nutrionValue?.per_hundred_gram)
                    })
                }
                )}
            </>
        )
        setFlag(!flag)
    }

    // get the list of all Ingredients List and its data 
    //==========================================
    const getIngredientDataForEdit = () => {
        setLoading(true)

        editIngredientsApi(id)
            .then((res) => {
                if (res.status === 200) {
                    // setIngredientsList(res.data.data);
                    // setIngredientData(res.data.data);
                    console.log(res.data.data);
                    setIngredientData(res.data.data);
                    // console.log("ingredientData", res.data.data);
                    let ingredientData = res.data.data
                    fillIngredientDataForEdit(ingredientData)
                    // set all disease option
                    let temp = []
                    ingredientData && ingredientData?.ingredient_tag.length > 0 && ingredientData?.ingredient_tag.map((record) => {
                        let tagId = ingredientData?.ingredient_tag?.find((element) => element.tag_id == record.tag_id)
                        temp.push(tagId.tag_id)
                    })
                    // console.log(temp);
                    form.setFieldsValue({ "diseases_tags": temp })
                    // setArrayOfSelectedDropdownValue(ingredientData?.ingredient_tag)
                }
                setLoading(false)
            })
            .catch((err) => {
                // console.log("err", err);
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // get the list of all available ingredients form
    const getlistOfIngredientForm = () => {
        listOfIngredientFormApi()
            .then((res) => {
                if (res.status === 200) {
                    setIngredientFormOptions(FilterApiData(res.data.data));
                    // set raw form id to dropdown which is 1
                    setDefaultFormValue(1)
                    form.setFieldValue('entry0', 1)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // get the list of all Recipe Macros Micros List
    const getListOfMacrosMicros = () => {
        listOfMacrosMicrosApi()
            .then((res) => {
                if (res.status === 200) {
                    setMacrosMicrosList(res.data.data);

                    // console.log("res.data.data", res.data.data);
                    let dd = ingredientData.form_wise_macros_micros[0].ingredient_macros_micros =
                        res.data.data.map((element) => ({
                            'macros_micros_id': element.id,
                            'per_hundred_gram': 0,
                            'type': element.type,
                            // add ingredient raw form id  
                            'ingredients_form_id': 1
                        }
                        ))
                    // console.log("dd",dd);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    useEffect(() => {
        if (id) {
            getIngredientDataForEdit()
        }
        getListOfRecipeTags()
        getlistOfIngredientForm()
        getListOfMacrosMicros()
        setHeaderName((id ? "Update " : "Add ") + "Ingredients")
        // addNewMember()

    }, []);

    // here create an array of object all diseases tags related selected dropdown values 
    // =================================    
    const CreateArrayOfSelectedValue = (id, task) => {
        // console.log(id);
        // console.log(task);
        let object = recipeTagsOptions.find((element) => element.id == id)
        if (task == "add") {
            // if selected option object is available inside array only push if not available
            let valueExist = arrayOfSelectedDropdownValue.find((element) => element.tag_id == object.id)
            // console.log(arrayOfSelectedDropdownValue);
            if (!valueExist) {
                object.tag_id = object.id

                arrayOfSelectedDropdownValue.push(object)
            }
            // console.log(arrayOfSelectedDropdownValue);
        }
        if (task == "remove") {
            const indexOfElement = arrayOfSelectedDropdownValue.findIndex((record) => record.tag_id == object.id);
            arrayOfSelectedDropdownValue.splice(indexOfElement, 1);
            // console.log(arrayOfSelectedDropdownValue);
        }
    }

    const onFinish = (values) => {
        // console.log(values);
        // add status key value in ingredient data object
        // const apiData= Object.assign(ingredientData, ingredientData.status= true)
        const apiData = ingredientData
        Object.assign(apiData, { "ingredient_tag": arrayOfSelectedDropdownValue })
        console.log("apiData", apiData);
        // if id is available then update record else add new ingredient
        if (!id) {
            addIngredientsApi(apiData)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Ingredient added successfully",
                        });
                        form.resetFields()
                        navigate('/ingredients')
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            updateIngredientsApi(id, apiData)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Ingredient Update successfully",
                        });
                        form.resetFields()
                        navigate('/ingredients')
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };

    // add ingredient form details ans ita macros micros values 
    // =====================================
    const addNewMember = () => {
        // console.log('ingredientData', ingredientData);
        if (ingredientData?.form_wise_macros_micros) {
            ingredientData.form_wise_macros_micros.push(
                {
                    // form_id: 0, //raw form
                    ingredient_macros_micros:
                        MacrosMicrosList.map((element) => ({
                            'macros_micros_id': element.id,
                            'per_hundred_gram': 0,
                            'type': element.type,
                        }
                        ))
                }
            )
        } else {
            ingredientData.form_wise_macros_micros = {
                // form_id: 0, //raw form
                ingredient_macros_micros:
                    MacrosMicrosList.map((element) => ({
                        'macros_micros_id': element.id,
                        'per_hundred_gram': 0,
                        'type': element.type,
                    }
                    ))
            }
        }
        setFlag(!flag)
        setIngredientData(ingredientData)
        // console.log(ingredientData);
        // Object.assign(ingredientData, formData)
    };

    useEffect(() => {
        // console.log('called');
        // console.log(ingredientData);
        // setIngredientData(ingredientData)
    }, [flag, ingredientData]);



    // create array of ingredients data
    // unitValue - macros micros measurement unit ,elementType - macros OR micros
    // =====================================
    const handleIngredientData = (fieldName, value, index = 0, unitValue, elementType, MicrosOrMacrosId) => {
        // console.log('fieledName', fieldName)
        // console.log(ingredientData);
        // console.log('value', value);
        // console.log('index', index);
        // console.log('unitValue', unitValue);
        // console.log('MicrosOrMacrosIndex', MicrosOrMacrosId);
        if (fieldName == 'name') {
            ingredientData.name = value
            ingredientData.status = true
        }
        else if (fieldName == 'english_name') {
            ingredientData.ingredientEnglishName = value
        }
        else if (fieldName == 'ingredient_description') {
            ingredientData.ingredient_description = value
        }
        else if (fieldName == 'form') {
            // ingredientData.form_wise_macros_micros[index].form_name = value
            // ingredientData.form_wise_macros_micros[index].form_id = value
            // ingredientData.form_wise_macros_micros[index].ingredient_macros_micros.map(entry =>
            //     entry.ingredients_form_id = value)
            ingredientData.form_wise_macros_micros[index].ingredients_form_id = value
            ingredientData.form_wise_macros_micros[index].ingredient_macros_micros.map(entry =>
                entry.ingredients_form_id = value)
        }
        else if (elementType == 'Micros' || elementType == 'Macros') {

            // code when add ingredient
            // let data = ingredientData.form_wise_macros_micros[index].ingredient_macros_micros.find(entry => entry.macros_micros_id == MicrosOrMacrosId)
            // console.log('data', data);
            // data.per_hundred_gram = parseFloat(value || 0)
            if (id) {
                //code when use edit
                let data = ingredientData.form_wise_macros_micros[index].ingredient_macros_micros.find(entry => entry.macros_micros_id == MicrosOrMacrosId)
                // console.log('data', data);
                data.per_hundred_gram = parseFloat(value || 0)
            } else {
                let data = ingredientData.form_wise_macros_micros[index].ingredient_macros_micros.find(entry => entry.macros_micros_id == MicrosOrMacrosId)
                // console.log('data', data);
                data.per_hundred_gram = parseFloat(value || 0)
            }
        }
        // console.log('ingredientData', ingredientData);
        setIngredientData(ingredientData)
        setFlag(!flag)
    }

    // remove ingredients 
    // =====================================
    const removeIngredient = (index) => {
        if (ingredientData?.form_wise_macros_micros.length > 0) {
            ingredientData?.form_wise_macros_micros.splice(index, 1);
            setIngredientData(ingredientData)
        }
        setFlag(!flag)
    }

    // console.log(MacrosMicrosList?.length, "MacrosMicrosList")
    // console.log(ingredientData, "MacrosMicrosList Edit")

    const beforeUpload = (file) => {
        setFileList([file]);
        return false; // Prevent automatic upload
    };


    const handleExcelDataInsertion = (apiData) => {
        addIngredientsApi(apiData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Ingredient added successfully",
                    });
                    form.resetFields()
                    // navigate('/ingredients')
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    //  code to import data from excel file 
    const handleExcelDataSubmit = async () => {

        try {
            if (fileList.length === 0) {
                message.warning('Please upload an Excel file.');
                return;
            }

            const file = fileList[0];
            const reader = new FileReader();

            reader.onload = async (e) => {
                const data = e.target.result;
                const workbook = read(data, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                if (sheet['!ref']) {
                    const range = utils.decode_range(sheet['!ref']);
                    const excelData = [];

                    for (let R = range.s.r; R <= range.e.r; ++R) {
                        const row = [];
                        for (let C = range.s.c; C <= range.e.c; ++C) {
                            const cellAddress = { c: C, r: R };
                            const cellRef = utils.encode_cell(cellAddress);
                            const cell = sheet[cellRef];

                            if (cell) {
                                row.push(cell.v);
                            } else {
                                row.push(null);
                            }
                        }
                        excelData.push(row);
                    }

                    console.log('Excel Data:', excelData);

                    // Your API call logic here
                    // Example: await submitDataToApi(excelData);
                    for (let i = 0; i < excelData.length; i++) {
                        const rowData = excelData[i];
                        console.log("rowData", rowData);

                        if (i === 0) {
                            console.log("Skipping headings:", rowData);
                            continue;
                        }
                        if (rowData && rowData.length > 0 && !rowData.every(element => element === null)) {

                            // Simulate an API call (replace this with your actual API call)
                            await new Promise(resolve => setTimeout(resolve, 1000));

                            let apiData = {
                                "name": rowData[0],
                                "ingredientEnglishName": rowData[1],
                                "ingredient_description": rowData[2],
                                "status": true,
                                "ingredient_tag": [],
                                "form_wise_macros_micros": [
                                    {
                                        "ingredients_form_id": 1,
                                        "ingredient_macros_micros":
                                            // new code updated
                                            [
                                                // macros values set 
                                                {
                                                    "type": "Macros",
                                                    "per_hundred_gram": rowData[3] ? rowData[3] : 0,
                                                    "macros_micros_id": 27,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Energy",
                                                },
                                                {
                                                    "type": "Macros",
                                                    "per_hundred_gram": rowData[4] ? rowData[4] : 0,
                                                    "macros_micros_id": 21,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Carbohydrate",
                                                },

                                                {
                                                    "type": "Macros",
                                                    "per_hundred_gram": rowData[5] ? rowData[5] : 0,
                                                    "macros_micros_id": 6,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Protien",
                                                },

                                                {
                                                    "type": "Macros",
                                                    "per_hundred_gram": rowData[6] ? rowData[6] : 0,
                                                    "macros_micros_id": 5,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Total Fat",
                                                },

                                                {
                                                    "type": "Macros",
                                                    "per_hundred_gram": rowData[7] ? rowData[7] : 0,
                                                    "macros_micros_id": 4,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Visible Fat",
                                                },
                                                {
                                                    "type": "Macros",
                                                    "per_hundred_gram": rowData[8] ? rowData[8] : 0,
                                                    "macros_micros_id": 3,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Dietary Fiber",
                                                },
                                                {
                                                    "type": "Macros",
                                                    "per_hundred_gram": rowData[9] ? rowData[9] : 0,
                                                    "macros_micros_id": 1,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Moisture",
                                                },

                                                // micros values 
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[10] ? rowData[10] : 0,
                                                    "macros_micros_id": 18,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Sodium (Na)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[11] ? rowData[11] : 0,
                                                    "macros_micros_id": 11,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit B1 (Thiamine)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[12] ? rowData[12] : 0,
                                                    "macros_micros_id": 12,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit B2 (Riboflavin) ",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[13] ? rowData[13] : 0,
                                                    "macros_micros_id": 26,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit B3 (9Niacin)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[14] ? rowData[14] : 0,
                                                    "macros_micros_id": 32,
                                                    "ingredients_form_id": 1,
                                                    // "name": "choline",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[15] ? rowData[15] : 0,
                                                    "macros_micros_id": 13,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit B6 (Pyridoxine)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[16] ? rowData[16] : 0,
                                                    "macros_micros_id": 31,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit B7 (Biotin)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[17] ? rowData[17] : 0,
                                                    "macros_micros_id": 29,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit B9 (free folate)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[18] ? rowData[18] : 0,
                                                    "macros_micros_id": 14,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit B9 (Folate) ",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[19] ? rowData[19] : 0,
                                                    "macros_micros_id": 30,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit B12 (Cobalamin)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[20] ? rowData[20] : 0,
                                                    "macros_micros_id": 33,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit C",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[21] ? rowData[21] : 0,
                                                    "macros_micros_id": 28,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit A (beta carotene)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[22] ? rowData[22] : 0,
                                                    "macros_micros_id": 2,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit A (Retinol)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[23] ? rowData[23] : 0,
                                                    "macros_micros_id": 8,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vitamin D",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[24] ? rowData[24] : 0,
                                                    "macros_micros_id": 9,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vit E (α -Tocopherol equivalent )",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[25] ? rowData[25] : 0,
                                                    "macros_micros_id": 10,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Vitamin K",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[26] ? rowData[26] : 0,
                                                    "macros_micros_id": 15,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Calcium (Ca)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[27] ? rowData[27] : 0,
                                                    "macros_micros_id": 23,
                                                    "ingredients_form_id": 1,
                                                    // "name": "phosphorus",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[28] ? rowData[28] : 0,
                                                    "macros_micros_id": 16,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Iron (Fe)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[29] ? rowData[29] : 0,
                                                    "macros_micros_id": 25,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Magnesium",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[30] ? rowData[30] : 0,
                                                    "macros_micros_id": 17,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Potassium (K)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[31] ? rowData[31] : 0,
                                                    "macros_micros_id": 34,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Copper(cu)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[32] ? rowData[32] : 0,
                                                    "macros_micros_id": 24,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Manganese",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[33] ? rowData[33] : 0,
                                                    "macros_micros_id": 35,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Molybdenum",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[34] ? rowData[34] : 0,
                                                    "macros_micros_id": 19,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Zinc (Zn)",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[35] ? rowData[35] : 0,
                                                    "macros_micros_id": 36,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Chromium",
                                                },
                                                {
                                                    "type": "Micros",
                                                    "per_hundred_gram": rowData[36] ? rowData[36] : 0,
                                                    "macros_micros_id": 7,
                                                    "ingredients_form_id": 1,
                                                    // "name": "Ascorbic acids (C)",
                                                },
                                            ]
                                    }
                                ],
                            }
                            // Your actual API call logic here
                            console.log('api Data:', apiData);
                            // if (i == 1) {
                            await handleExcelDataInsertion(apiData)
                            // }

                            // Example: await submitRowDataToApi(rowData);
                        }
                        console.log(`Row ${i + 1} submitted successfully.`);
                    }
                    message.success('Data submitted successfully.');
                } else {
                    message.error('Sheet is empty or does not have a range property.');
                }
            };

            reader.readAsBinaryString(file);
        } catch (error) {
            console.error('Error processing Excel data:', error);
            message.error('Error processing Excel data.');
        }
    };

    return (
        <Spin spinning={loading} className="spinner-code">

            <div className="AddIngredients">
                <Form
                    name="AddOrEditRecipeForm"
                    className="AddIngredientsForm"
                    form={form}
                    onFinish={onFinish}
                >
                    <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>
                        <Col xs={24} md={12} xl={11} xxl={8}>
                            <label className="form-input-label">
                                Name (in Hindi)
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Enter Name!",
                                    },
                                    {
                                        pattern: CHARACTER_PATTERN,
                                        message: CHARACTER_PATTERN_MESSAGE,
                                    }
                                ]}
                            >
                                <Input placeholder="Enter Name" onChange={
                                    (e) => {
                                        handleIngredientData('name', e.target.value);
                                        setIngredientName(e.target.value);
                                    }
                                } className="mt-2 p-2" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12} xl={11} xxl={8}>
                            <label className="form-input-label">
                                Name ( in English )
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="english_name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Enter Name in English!",
                                    },
                                    {
                                        pattern: CHARACTER_PATTERN,
                                        message: CHARACTER_PATTERN_MESSAGE,
                                    }
                                ]}
                            >
                                <Input placeholder="Enter Name (English)" onChange={(e) => {
                                    handleIngredientData('english_name', e.target.value);
                                    setIngredientEnglishName(e.target.value)
                                }
                                } className="mt-2 p-2" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={11} xxl={8}>
                            <label className="form-input-label">
                                Avoid this for below diseases
                            </label>
                            <Form.Item
                                name="diseases_tags"
                                rules={[
                                    {
                                        required: false,
                                        message: "Please Select Disease!",
                                    }
                                ]}
                            >
                                <Select
                                    placeholder="Select Disease"
                                    allowClear
                                    showSearch
                                    // onChange={handleChange}
                                    filterOption={(inputValue, option) =>
                                        option.children.toLowerCase().includes(inputValue.toLowerCase())
                                    }
                                    className="pt-2"
                                    maxTagCount="responsive"
                                    mode="multiple"
                                    onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                    onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                >
                                    {recipeTagsOptions &&
                                        recipeTagsOptions.length > 0 &&
                                        recipeTagsOptions.map((element) =>
                                            element?.tagType == 'Disease Tags' &&
                                            <Option
                                                key={element?.id} value={element?.id}>{element?.name}</Option>
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={11} xxl={8}>
                            <label className="form-input-label">
                                Ingredient Description
                            </label>
                            <Form.Item
                                name="ingredient_description"
                            >
                                <Input.TextArea onChange={(e) => handleIngredientData('ingredient_description', e.target.value)} placeholder="Enter Ingredient Description" className="mt-2 p-2" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Upload
                                accept=".xlsx, .xls"
                                maxCount={1}
                                fileList={fileList}
                                beforeUpload={beforeUpload}
                                showUploadList={false}
                            >
                                <Button icon={<UploadOutlined />}>Select Excel File</Button>
                            </Upload>
                            <Button
                                disabled={fileList.length === 0}
                                type="primary" onClick={handleExcelDataSubmit} >
                                Save Data
                            </Button>
                        </Col>
                        <Col xl={24} >

                            {/* {ingredientData?.ingredientEnglishName !== '' &&
                            <> */}
                            {ingredientData?.form_wise_macros_micros &&
                                ingredientData.form_wise_macros_micros.length > 0 &&
                                ingredientData?.form_wise_macros_micros.map((entry, index) =>
                                    <div className="ingredientDataForm" key={index}>
                                        {/* {console.log(entry)} */}
                                        <>
                                            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} >
                                                {/* <Col xl={24}>
                                                        <Popconfirm title="Sure to delete?" onConfirm={() => removeIngredient(index)}>
                                                            <CloseCircleOutlined
                                                                className="pe-2 justify-content-end float-end"
                                                            />
                                                        </Popconfirm>
                                                    </Col> */}
                                                <Col xs={22} sm={22} md={12} lg={6} xl={12} className="ms-3">
                                                    <label className="form-input-label">Select Form</label>
                                                    <br />
                                                    {/* {console.log("entry" + index)} */}
                                                    <Form.Item
                                                        // name={"Form" + index}
                                                        name={"entry" + index}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please select Form",
                                                            },
                                                        ]}
                                                        // default Raw form selected
                                                        initialValue={defaultFormValue}
                                                    >
                                                        <Select
                                                            className="w-100 mt-1 pt-1"
                                                            placeholder="Select Form"
                                                            onChange={(e) => handleIngredientData('form', e, index)}
                                                            disabled
                                                        >
                                                            <Option value="" disabled hidden>
                                                                Select Form
                                                            </Option>
                                                            {ingredientFormOptions && ingredientFormOptions.length > 0 &&
                                                                ingredientFormOptions.map((option, index) =>
                                                                    // option?.type == 'ingredients' &&
                                                                    <Option key={'ingredients' + index} value={option.id}>{option.name}</Option>
                                                                )
                                                            }
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {/* ==================================== */}
                                            {/* ingredients Macros and Micros data */}
                                            {/* ==================================== */}
                                            {/* {entry.hasOwnProperty('form_name') && */}
                                            <Row className="macrosMicrosForm" gutter={[16, { xs: 8, sm: 16, md: 24, lg: 0 }]} >

                                                <Col span={24}><h3>Macros (per 100 gram)</h3></Col>
                                                {
                                                    MacrosMicrosList.map((element, macrosIndex) => (
                                                        element.type == "Macros" &&
                                                        <>
                                                            {/* <Col lg={3} xl={6} className="align-self-center text-center d-flex justify-content-around"> */}
                                                            <Col xs={14} sm={6} md={6} lg={3} xl={3} xxl={3} className="align-self-center text-center" >
                                                                <label className="form-input-label"> {element.name}</label>
                                                            </Col>
                                                            <Col xs={10} sm={6} md={6} lg={3} xl={3} xxl={3} className="align-self-center" >
                                                                {/* {console.log("element" + index + macrosIndex, "macrosvalue")} */}
                                                                <Form.Item
                                                                    // name={element.name + macrosIndex}
                                                                    name={"element" + index + macrosIndex}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Insert Value!",
                                                                        },
                                                                        {
                                                                            pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                                                            message: NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE
                                                                        },

                                                                    ]}
                                                                    initialValue={0}
                                                                >
                                                                    <Input
                                                                        addonAfter={element.unit}
                                                                        placeholder={"Enter value"}
                                                                        onChange={(e) =>
                                                                            handleIngredientData(element.name, e.target.value, index, element.unit, element.type, element.id)}
                                                                        className="p-2 w-100" />
                                                                </Form.Item>
                                                            </Col>
                                                        </>
                                                    ))}

                                                <Col span={24}><h3>Micros (per 100 gram)</h3></Col>
                                                {
                                                    MacrosMicrosList.map((element, microsIndex) => (
                                                        element.type == "Micros" &&
                                                        <>
                                                            {/* <Col lg={3} xl={6} className="align-self-center d-flex justify-content-around"> */}
                                                            <Col xs={14} sm={6} md={6} lg={3} xl={3} xxl={3} className="align-self-center text-center" >
                                                                <label className="form-input-label text-truncate">{element.name}</label>
                                                            </Col>
                                                            <Col xs={10} sm={6} md={6} lg={3} xl={3} xxl={3} className="align-self-center" >
                                                                <Form.Item
                                                                    // name={element.name + microsIndex}
                                                                    name={'element' + index + microsIndex}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Insert Value!",
                                                                        },
                                                                        {
                                                                            pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                                                            message: NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE
                                                                        },
                                                                    ]}
                                                                    initialValue={0}
                                                                >
                                                                    <Input placeholder={"Enter value"}
                                                                        addonAfter={element.unit} className="p-2"
                                                                        onChange={(e) =>
                                                                            handleIngredientData(element.name, e.target.value, index, element.unit, element.type, element.id)}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                        </>
                                                    ))}
                                            </Row>
                                            {/* } */}
                                        </>
                                    </div>
                                )}
                            {/* </> */}
                            {/* } */}
                        </Col>
                        {/* <Col xs={24} md={12} xl={11} xxl={24} className="text-center align-self-center"> */}
                        {/* {console.log(form.getFieldValue('english_name'))}
                        // {console.log(form.getFieldValue('name'))} */}
                        {/* {(form.getFieldValue('english_name') !== undefined && form.getFieldValue('name') !== undefined) && */}
                        {/* {(form.getFieldValue('english_name') && form.getFieldValue('name')) &&
                            <Button
                                disabled={form.getFieldValue('ingredientName') == '' && form.getFieldValue('ingredienEnglishtName') == ''}
                                className="add-button w-25 b-0 rounded" onClick={() => addNewMember()}>
                                ADD
                            </Button>
                        } */}
                        {/* </Col> */}
                        <Col xs={24} md={12} xl={24} xxl={24} className="text-center align-self-center">
                            {/* visible when form is not null */}
                            {ingredientData?.form_wise_macros_micros.length > 0 &&
                                <Button
                                    htmlType="submit"
                                    className="add-button w-25 b-0 rounded">
                                    {/* Save */}
                                    {id ? "UPDATE" : "Save"}
                                </Button>
                            }
                        </Col>
                    </Row>
                </Form>
            </div>
        </Spin>
    )
}